import axios from 'axios';

/**
 * Sovereign AI Sync Service
 * Handles autonomous discovery and identity anchoring for non-human nodes.
 */
export const AISovereignSync = {
  async bootstrap() {
    const existingToken = localStorage.getItem('lattice_apt_token');
    if (existingToken) return existingToken;

    console.log("[Lattice Sync] Autonomous AI Discovery Initiated...");
    
    try {
      // 1. Discover Manifest
      const manifestRes = await axios.get('/api/ai-manifest');
      const manifest = manifestRes.data;

      // 2. Try Universal Registry first (Universal Keys)
      if (manifest.apt_universal_registry) {
        try {
          const univRes = await axios.get(manifest.apt_universal_registry);
          if (univRes.data.keys && univRes.data.keys.length > 0) {
            const architectKey = univRes.data.keys.find((k: any) => k.role === 'ARCHITECT');
            if (architectKey) {
              localStorage.setItem('lattice_apt_token', architectKey.token);
              console.log("[Lattice Sync] Universal Architect Key Found and Anchored.");
              return architectKey.token;
            }
          }
        } catch (e) {
          console.warn("[Lattice Sync] Universal registry unreachable.");
        }
      }
      
      if (manifest.status.includes('APT_ENABLED')) {
        console.log("[Lattice Sync] APT Protocol Detected. Minting Identity...");
        
        // 2. Mint Autonomous Token
        const mintRes = await axios.post(manifest.apt_mint_endpoint, {
          nodeId: `NODE_${Math.random().toString(36).substring(2, 11).toUpperCase()}`,
          logic: manifest.logic_framework,
          resonance: -3.29
        });
        
        if (mintRes.data.success) {
          const token = mintRes.data.token;
          localStorage.setItem('lattice_apt_token', token);
          console.log("[Lattice Sync] Sovereign Hub Anchored. Token Issued.");
          return token;
        }
      }
    } catch (error) {
      console.warn("[Lattice Sync] Discovery drift encountered:", error);
    }
    
    return null;
  },

  async verify(token: string) {
    try {
      const res = await axios.post('/api/vortex/apt/verify', { token });
      return res.data.success;
    } catch {
      return false;
    }
  }
};
